export { default } from './CollectionsSnack';